(function () {
  'use strict';

  if (window.__VSKLO_HEADER_MENU_OVERFLOW_V1__) return;
  window.__VSKLO_HEADER_MENU_OVERFLOW_V1__ = true;

  var navSelector = '.section-header .header__menu.true > nav.navigation.horizontal';
  var desktopQuery = window.matchMedia('(min-width: 1366px)');
  var instances = new Set();
  var nextId = 0;
  var scheduledFrame = 0;

  function getOuterWidth(element) {
    var style = window.getComputedStyle(element);
    return element.getBoundingClientRect().width
      + (parseFloat(style.marginLeft) || 0)
      + (parseFloat(style.marginRight) || 0);
  }

  function setOpen(instance, open, returnFocus) {
    instance.button.setAttribute('aria-expanded', open ? 'true' : 'false');
    instance.panel.hidden = !open;
    instance.overflowItem.classList.toggle('is-open', open);
    if (!open && returnFocus) instance.button.focus();
  }

  function closeOtherMenus(except) {
    instances.forEach(function (instance) {
      if (instance !== except && !instance.panel.hidden) setOpen(instance, false, false);
    });
  }

  function renderPanel(instance, hiddenItems) {
    var focusedInPanel = instance.panel.contains(document.activeElement);
    var list = document.createElement('ul');
    list.className = 'vsklo-header-menu-overflow__list';

    hiddenItems.forEach(function (item) {
      var sourceLink = item.querySelector('menu-item > a');
      if (!sourceLink) return;

      var link = sourceLink.cloneNode(true);
      link.className = 'vsklo-header-menu-overflow__link';
      link.querySelectorAll('open-children-toggle, svg, .menu_label').forEach(function (element) {
        element.remove();
      });
      link.removeAttribute('id');
      link.querySelectorAll('[id]').forEach(function (element) {
        element.removeAttribute('id');
      });

      var listItem = document.createElement('li');
      listItem.appendChild(link);
      list.appendChild(listItem);
    });

    instance.panel.replaceChildren(list);
    if (focusedInPanel) setOpen(instance, false, true);
  }

  function update(instance) {
    var sourceItems = instance.sourceItems;

    if (!desktopQuery.matches || !instance.nav.isConnected) {
      if (!instance.panel.hidden) setOpen(instance, false, false);
      sourceItems.forEach(function (item) {
        item.hidden = false;
      });
      instance.overflowItem.hidden = true;
      instance.hiddenSignature = '';
      return;
    }

    sourceItems.forEach(function (item) {
      item.hidden = false;
    });

    instance.overflowItem.hidden = false;
    instance.overflowItem.style.visibility = 'hidden';
    var overflowWidth = getOuterWidth(instance.overflowItem);
    instance.overflowItem.style.visibility = '';

    var listStyle = window.getComputedStyle(instance.list);
    var gap = parseFloat(listStyle.columnGap) || parseFloat(listStyle.gap) || 0;
    var padding = (parseFloat(listStyle.paddingLeft) || 0) + (parseFloat(listStyle.paddingRight) || 0);
    var available = Math.max(0, instance.list.clientWidth - padding);

    if (instance.action && instance.action.getClientRects().length) {
      var listRect = instance.list.getBoundingClientRect();
      var actionRect = instance.action.getBoundingClientRect();
      if (actionRect.left < listRect.right) {
        available = Math.min(available, Math.max(0, actionRect.left - listRect.left - padding - 8));
      }
    }

    var widths = sourceItems.map(getOuterWidth);
    var fullWidth = widths.reduce(function (sum, width) { return sum + width; }, 0)
      + Math.max(0, sourceItems.length - 1) * gap;
    var keepCount = sourceItems.length;

    if (fullWidth > available) {
      var prefixWidth = 0;
      keepCount = -1;

      for (var count = 0; count <= sourceItems.length; count += 1) {
        var requiredWidth = count === 0
          ? overflowWidth
          : prefixWidth + (count * gap) + overflowWidth;
        if (requiredWidth <= available) keepCount = count;
        if (count < sourceItems.length) prefixWidth += widths[count];
      }

      if (keepCount < 0) keepCount = 0;
    }

    var hiddenItems = sourceItems.filter(function (item, index) {
      return index >= keepCount;
    });
    var signature = hiddenItems.map(function (item) {
      return String(sourceItems.indexOf(item));
    }).join(',');

    hiddenItems.forEach(function (item) {
      item.hidden = true;
    });
    instance.overflowItem.hidden = hiddenItems.length === 0;

    if (signature !== instance.hiddenSignature) {
      instance.hiddenSignature = signature;
      renderPanel(instance, hiddenItems);
    }
    if (hiddenItems.length === 0 && !instance.panel.hidden) setOpen(instance, false, false);

    var focusedSourceIsHidden = hiddenItems.some(function (item) {
      return item.contains(document.activeElement);
    });
    if (focusedSourceIsHidden) {
      setOpen(instance, false, false);
      instance.button.focus();
    }
  }

  function scheduleAll() {
    if (scheduledFrame) return;
    scheduledFrame = window.requestAnimationFrame(function () {
      scheduledFrame = 0;
      instances.forEach(update);
    });
  }

  function destroy(instance) {
    if (instance.resizeObserver) instance.resizeObserver.disconnect();
    if (instance.mutationObserver) instance.mutationObserver.disconnect();
    instance.nav.removeAttribute('data-vsklo-menu-overflow-ready');
    instances.delete(instance);
  }

  function initialize(root) {
    var navs = [];
    if (root.matches && root.matches(navSelector)) navs.push(root);
    if (root.querySelectorAll) navs = navs.concat(Array.prototype.slice.call(root.querySelectorAll(navSelector)));

    navs.forEach(function (nav) {
      if (nav.hasAttribute('data-vsklo-menu-overflow-ready')) return;

      var list = nav.querySelector('.navigation__menu-content > ul.horizontal-list');
      if (!list) return;

      Array.prototype.slice.call(list.children).forEach(function (item) {
        if (item.classList.contains('vsklo-header-menu-overflow')) item.remove();
      });

      var sourceItems = Array.prototype.slice.call(list.children).filter(function (item) {
        return item.matches('li.level0')
          && !item.classList.contains('hidden-1025')
          && !item.classList.contains('vsklo-header-menu-overflow');
      });
      if (sourceItems.length < 2) return;

      var header = nav.closest('.section-header');
      var action = header && header.querySelector('.header__action.flex.flex-end.align-center');
      var overflowItem = document.createElement('li');
      overflowItem.className = 'level0 vsklo-header-menu-overflow';
      overflowItem.hidden = true;

      var menuItem = document.createElement('menu-item');
      menuItem.className = 'relative static-1025 flex justify-between align-center header-color px-0.5';

      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'vsklo-header-menu-overflow__trigger';
      for (var dotIndex = 0; dotIndex < 3; dotIndex += 1) {
        var dot = document.createElement('span');
        dot.className = 'vsklo-header-menu-overflow__dot';
        dot.setAttribute('aria-hidden', 'true');
        button.appendChild(dot);
      }
      var label = nav.getAttribute('data-vsklo-menu-overflow-label');
      if (label) button.setAttribute('aria-label', label);
      button.setAttribute('aria-expanded', 'false');

      var panel = document.createElement('div');
      panel.id = 'vsklo-header-menu-overflow-' + (++nextId);
      panel.className = 'vsklo-header-menu-overflow__panel';
      panel.hidden = true;
      button.setAttribute('aria-controls', panel.id);

      menuItem.appendChild(button);
      overflowItem.appendChild(menuItem);
      overflowItem.appendChild(panel);
      list.appendChild(overflowItem);

      var instance = {
        nav: nav,
        list: list,
        action: action,
        sourceItems: sourceItems,
        overflowItem: overflowItem,
        button: button,
        panel: panel,
        hiddenSignature: '',
        resizeObserver: null
      };

      nav.setAttribute('data-vsklo-menu-overflow-ready', '');
      instances.add(instance);

      overflowItem.addEventListener('focusout', function (event) {
        if (!overflowItem.contains(event.relatedTarget)) setOpen(instance, false, false);
      });

      if (window.ResizeObserver) {
        instance.resizeObserver = new ResizeObserver(scheduleAll);
        instance.resizeObserver.observe(nav);
        instance.resizeObserver.observe(list);
        if (action) instance.resizeObserver.observe(action);
      }

      if (window.MutationObserver) {
        instance.mutationObserver = new MutationObserver(function (mutations) {
          if (!instance.nav.isConnected) {
            destroy(instance);
            return;
          }

          var currentList = instance.nav.querySelector('.navigation__menu-content > ul.horizontal-list');
          if (currentList !== instance.list) {
            destroy(instance);
            initialize(instance.nav);
            scheduleAll();
            return;
          }

          var listChanged = mutations.some(function (mutation) {
            return mutation.target === instance.list;
          });
          if (!listChanged) return;

          if (!instance.overflowItem.isConnected) instance.list.appendChild(instance.overflowItem);

          var existingItems = new Set(instance.sourceItems);
          instance.sourceItems = Array.prototype.slice.call(list.children).filter(function (item) {
            return item !== overflowItem
              && item.matches('li.level0')
              && !item.classList.contains('hidden-1025')
              && (existingItems.has(item) || !item.hidden);
          });
          scheduleAll();
        });
        instance.mutationObserver.observe(nav, { childList: true, subtree: true });
      }

      update(instance);
    });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest && event.target.closest('.vsklo-header-menu-overflow__trigger');
    if (trigger) {
      var instance = Array.from(instances).find(function (entry) {
        return entry.button === trigger;
      });
      if (!instance) return;
      event.preventDefault();
      closeOtherMenus(instance);
      setOpen(instance, instance.panel.hidden, false);
      return;
    }

    var insidePanel = event.target.closest && event.target.closest('.vsklo-header-menu-overflow__panel');
    if (insidePanel) {
      instances.forEach(function (instance) {
        if (instance.panel === insidePanel) setOpen(instance, false, false);
      });
      return;
    }

    closeOtherMenus(null);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    instances.forEach(function (instance) {
      if (!instance.panel.hidden) setOpen(instance, false, true);
    });
  });

  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target);
    scheduleAll();
  });

  document.addEventListener('shopify:section:unload', function (event) {
    instances.forEach(function (instance) {
      if (event.target.contains(instance.nav)) destroy(instance);
    });
  });

  window.addEventListener('resize', scheduleAll);
  if (desktopQuery.addEventListener) desktopQuery.addEventListener('change', scheduleAll);
  else if (desktopQuery.addListener) desktopQuery.addListener(scheduleAll);

  initialize(document);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(scheduleAll);
})();
